import { useMemo, useState } from "react";
import useConversationsList from "./useConversationsList";
import { filterConversations, sortConversations } from "./filterAndSortConversations";
import ConversationFilters from "./ConversationFilters";
import ConversationTile from "./ConversationTile";

// The filters+tile-grid body of the conversation template list, extracted so
// it can be embedded both standalone (ConversationListView, /conversations-new)
// and inside the /conversations-menu dashboard.
export default function ConversationTemplatesSection() {
    const [conversationType, setConversationType] = useState(3);
    const [level, setLevel] = useState("");
    const [isPublic, setIsPublic] = useState("");
    const [search, setSearch] = useState("");
    const [sort, setSort] = useState("newest");

    const { conversations, conversationTypes, levels, usedConversationIds } = useConversationsList(conversationType);

    const visibleConversations = useMemo(() => {
        const filtered = filterConversations(conversations, { search, level, isPublic });
        return sortConversations(filtered, sort);
    }, [conversations, search, level, isPublic, sort]);

    return (
        <div>
            <ConversationFilters
                conversationType={conversationType}
                onConversationTypeChange={setConversationType}
                conversationTypes={conversationTypes}
                level={level}
                onLevelChange={setLevel}
                levels={levels}
                isPublic={isPublic}
                onIsPublicChange={setIsPublic}
                search={search}
                onSearchChange={setSearch}
                sort={sort}
                onSortChange={setSort}
            />
            <p className="conv-progress-list-count">Знайдено: {visibleConversations.length}</p>

            <div className="conversation-plate-container scrooll">
                {visibleConversations.map((conversation) => (
                    <ConversationTile
                        key={conversation.id}
                        conversation={conversation}
                        isUsed={usedConversationIds.has(conversation.id)}
                    />
                ))}
            </div>
        </div>
    );
}
